import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    basic: (props: any) => ({
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf'}`,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem .5rem',
        textTransform: 'uppercase' as 'uppercase',
        fontSize: '1.1rem',
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333333',
        opacity: '1',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight,
            color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF',
            opacity: 1
        },
        '&.Mui-selected': {
            backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
            color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF'
        },
        ...props?.tabClasses?.root
    }),
    basicFontThin: (props: any) => ({
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf'}`,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '.5rem',
        textTransform: 'uppercase' as 'uppercase',
        fontSize: '1.1rem',
        lineHeight: '1.5rem',
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333333',
        opacity: '1',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight,
            color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF',
            opacity: 1
        },
        '&.Mui-selected': {
            backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
            color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF'
        },
        ...props?.tabClasses?.root
    }),
    thin: (props: any) => ({
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf'}`,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '.25rem .5rem',
        textTransform: 'uppercase' as 'uppercase',
        fontSize: '.9rem',
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333333',
        opacity: '1',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight,
            color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF',
            opacity: 1
        },
        '&.Mui-selected': {
            backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
            color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF'
        },
        ...props?.tabClasses?.root
    }),
    selected: (props: any) => ({ ...props?.tabClasses?.selected })
}));